"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebProvider = void 0;
const types_1 = require("../types");
class WebProvider {
    constructor(provider, options, eventBus, address = null) {
        this.provider = provider;
        this.connectionOptions = options;
        this.address = address;
        this.authenticated = false;
        this.signature = null;
    }
    off(event, handler) {
    }
    on(event, handler) {
    }
    init() {
        if (window !== undefined) {
            const params = new URLSearchParams(window.location.search);
            const address = params.get("address");
            if (null !== address) {
                this.setState({
                    address,
                    signature: params.get("signature"),
                    authenticated: true
                });
            }
        }
        return Promise.resolve(true);
    }
    login(token) {
        return this.provider.login({
            token,
            callbackUrl: this.connectionOptions.loginRedirectUrl,
        });
    }
    logout() {
        return this.provider.logout({
            callbackUrl: this.connectionOptions.logoutRedirectUrl,
        });
    }
    signTransaction(tx) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.provider.signTransaction(tx, {
                callbackUrl: this.connectionOptions.transactionRedirectUrl,
            });
            return null;
        });
    }
    signTransactions(transactions) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.provider.signTransactions(transactions, {
                callbackUrl: this.connectionOptions.transactionRedirectUrl,
            });
            return [];
        });
    }
    getAddress() {
        return this.address;
    }
    getSignature() {
        return this.signature;
    }
    getType() {
        return types_1.AuthProviderType.WEBWALLET;
    }
    setState({ address, signature, authenticated }) {
        this.address = address;
        this.signature = signature !== null && signature !== void 0 ? signature : null;
        this.authenticated = authenticated !== null && authenticated !== void 0 ? authenticated : false;
        return this;
    }
    getBaseProvider() {
        return this.provider;
    }
    toJson() {
        return {
            address: this.address,
            authProviderType: types_1.AuthProviderType.WEBWALLET,
            authenticated: this.authenticated
        };
    }
}
exports.WebProvider = WebProvider;
